// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input:checked~.dot{transform:translateX(100%)}input:checked~.block{background-color:#e7eaec}", ""]);
// Exports
module.exports = exports;
